import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
// import {
//   pastDateOnlyValidation,
//   futureDateWithTodayValidation,
// } from '@validations/utils';

const POSTINGS = FORM_FIELDS.EMPLOYEE.POSTINGS;
export const ABROAD_POSTING = POSTINGS.ABROAD_POSTING;
export const ATTACHMENT_POSTING = POSTINGS.ATTACHMENT_POSTING;
export const DEPUTATION_POSTING = POSTINGS.DEPUTATION_POSTING;
export const POSTING_RECORDS = POSTINGS.POSTING_RECORDS;
export const FOREIGN_TRAVEL = POSTINGS.FOREIGN_TRAVEL;

export const abroadPostingValidation = yup.object().shape({
  [POSTINGS.ABROAD_POSTING.COUNTRY]: yup
    .number()
    .typeError("Country is required")
    .required("Country is required"),
  [POSTINGS.ABROAD_POSTING.PURPOSE]: yup
    .string()
    .required("Purpose is required"),
  [POSTINGS.ABROAD_POSTING.FROM_DATE]: yup
    .string()
    // .test('validator-from-date', pastDateOnlyValidation)
    .required("From date is required"),
  // [POSTINGS.ABROAD_POSTING.TO_DATE]: yup
  //   .string()
  //   // .test('validator-to-date', futureDateWithTodayValidation)
  //   .required("To date is required"),
});

export const attachmentPostingValidation = yup.object().shape({
  [POSTINGS.ATTACHMENT_POSTING.POST]: yup.string().required("Post is required"),
  [POSTINGS.ATTACHMENT_POSTING.NAME_OF_OFFICE]: yup
    .number()
    .typeError("Name of office is required")
    .required("Name of office is required"),
  [POSTINGS.ATTACHMENT_POSTING.WING]: yup
    .number()
    .typeError("Wing is required")
    .required("Wing is required"),
  [POSTINGS.ATTACHMENT_POSTING.DIST]: yup
    .number()
    .typeError("Dist / Location is required")
    .required("Dist / Location is required"),
  [POSTINGS.ATTACHMENT_POSTING.FROM_DATE]: yup
    .string()
    .required("From date is required"),
  [POSTINGS.ATTACHMENT_POSTING.TO_DATE]: yup
    .string()
    .required("To date is required"),
});

export const contractualPostingValidation = yup.object().shape({
  [POSTINGS.CONTRACTUAL_POSTING.POST]: yup
    .string()
    .required("Post is required"),
  [POSTINGS.CONTRACTUAL_POSTING.NAME_OF_OFFICE]: yup
    .number()
    .typeError("Name of office is required")
    .required("Name of office is required"),
  [POSTINGS.CONTRACTUAL_POSTING.WING]: yup
    .number()
    .typeError("Wing is required")
    .required("Wing is required"),
  [POSTINGS.CONTRACTUAL_POSTING.DIST]: yup
    .number()
    .typeError("Dist / Location is required")
    .required("Dist / Location is required"),
  [POSTINGS.CONTRACTUAL_POSTING.FROM_DATE]: yup
    .string()
    .required("From date is required"),
  [POSTINGS.CONTRACTUAL_POSTING.TO_DATE]: yup
    .string()
    .required("To date is required"),
});

export const deputationPostingValidation = yup.object().shape({
  [POSTINGS.DEPUTATION_POSTING.POST]: yup.string().required("Post is required"),
  [POSTINGS.DEPUTATION_POSTING.ORGANIZATION]: yup
    .string()
    .required("Organization is required"),
  [POSTINGS.DEPUTATION_POSTING.FROM_DATE]: yup
    .string()
    // .test('validator-from-date', pastDateOnlyValidation)
    .required("From date is required"),
  // [POSTINGS.DEPUTATION_POSTING.TO_DATE]: yup
  //   .string()
  //   // .test('validator-to-date', futureDateWithTodayValidation)
  //   .required("To date is required"),
});

export const postingRecordPostingValidation = yup.object().shape({
  [POSTINGS.POSTING_RECORDS.POST]: yup.string().required("Post is required"),
  // [POSTINGS.POSTING_RECORDS.OFFICE_ID]: yup
  //   .number()
  //   .typeError("Office is required")
  //   .required("Office is required"),
  [POSTINGS.POSTING_RECORDS.UNIT_ID]: yup
    .number()
    .typeError("Wing is required")
    .required("Wing is required"),
  // [POSTINGS.POSTING_RECORDS.DISTRICT_ID]: yup
  //   .number()
  //   .typeError("District is required")
  //   .required("District is required"),
  [POSTINGS.POSTING_RECORDS.FROM_DATE]: yup
    .string()
    // .test('validator-from-date', pastDateOnlyValidation)
    .required("From date is required"),
  // [POSTINGS.POSTING_RECORDS.TO_DATE]: yup
  //   .string()
  //   // .test('validator-to-date', futureDateWithTodayValidation)
  //   .required("To date is required"),
  [POSTINGS.POSTING_RECORDS.GRADE]: yup.string().required("Grade is Required"),
  // [POSTINGS.POSTING_RECORDS.PAY_SCALE_MIN]: yup
  //   .string()
  //   .required("Pay scale minimum is required"),
  // [POSTINGS.POSTING_RECORDS.PAY_SCALE_MAX]: yup
  //   .string()
  //   .required("Pay scale maximum is required"),
});

export const foreignTravelPostingValidation = yup.object().shape({
  [POSTINGS.FOREIGN_TRAVEL.COUNTRY]: yup
    .number()
    .typeError("Country is required")
    .required("Country is required"),
  [POSTINGS.FOREIGN_TRAVEL.PURPOSE]: yup
    .string()
    .required("Purpose is required"),
  [POSTINGS.FOREIGN_TRAVEL.FROM_DATE]: yup
    .string()
    // .test('validator-from-date', pastDateOnlyValidation)
    .required("From date is required"),
  // [POSTINGS.FOREIGN_TRAVEL.TO_DATE]: yup
  //   .string()
  //   // .test('validator-to-date', futureDateWithTodayValidation)
  //   .required("To date is required"),
});

export type AbroadPostingsFormDataType = yup.InferType<
  typeof abroadPostingValidation
>;
export type AttachmentPostingFormDataType = yup.InferType<
  typeof attachmentPostingValidation
>;
export type ContractualPostingFormDataType = yup.InferType<
  typeof contractualPostingValidation
>;
export type DeputationPostingFormDataType = yup.InferType<
  typeof deputationPostingValidation
>;
export type PostingRecordPostingFormDataType = yup.InferType<
  typeof postingRecordPostingValidation
>;
export type ForeignTravelPostingFormDataType = yup.InferType<
  typeof foreignTravelPostingValidation
>;
